import { get } from '..';

const getChatbotSessions = (isDeleted: boolean = false) => get(`chatbot-api/chat-sessions?isDeleted=${isDeleted}`);

export default getChatbotSessions;
